import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Box,
  Flex,
} from "@chakra-ui/react";
import { AlertTriangle } from "lucide-react";

interface LocationDataWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  t: (key: string) => string;
}

export const LocationDataWarningModal: React.FC<LocationDataWarningModalProps> =
  ({ isOpen, onClose, onConfirm, t }) => {
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        size="md"
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader borderBottomWidth="1px" pb={4}>
            <Flex align="center" gap={3}>
              <Box>
                <AlertTriangle size={24} color="#F59E0B" />
              </Box>
              <Text fontSize="lg" fontWeight="600" color="#242E38">
                {t("locationDataWarningTitle")}
              </Text>
            </Flex>
          </ModalHeader>

          <ModalBody py={6}>
            <Text color="#242E38" fontSize="md" lineHeight="1.6">
              {t("locationDataWarningDescription")}
            </Text>
          </ModalBody>

          <ModalFooter borderTopWidth="1px" bg="white" gap={3}>
            <Button variant="ghost" color="#4A5568" onClick={onClose}>
              {t("cancel")}
            </Button>
            <Button
              layerStyle="ocean"
              _hover={{ layerStyle: "ocean" }}
              onClick={onConfirm}
            >
              {t("yesWantToContinue")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };
